module.exports = __webpack_public_path__ + "img/openbadge-type-2.dcbc8225.png";